// extracted by mini-css-extract-plugin
export default {"hintList":"SupportTicketInfo_hintList__ef2lS"};